export default {
	allAffiliatedCollaborativeListsHome: () => '/collaborativelists/0',
	buzzLists: (communityId = ':communityId') => `/buzz/${communityId}`,
	catalog: () => '/catalog/:catalogId',
	collaborativeList: (listId = ':listId') => `/list/${listId}`,
	collaborativeLists: () => `/collaborativelists/:communityId`,
	collaborativeListsIFrameHome: () => '/iframe/collaborativelists',
	communicationSettingsIFrameHome: () => '/iframe/communicationSettings',
	communicationSettings: () => '/communicationSettings',
	community: (
		communityId = ':communityId',
		reviewsCreatedDateMaxDaysBack = ':reviewsCreatedDateMaxDaysBack',
	) => `/community/${communityId}/home/${reviewsCreatedDateMaxDaysBack}`,
	communityHomeWithEventDetails: () =>
		'/community/:communityId/home/:reviewsCreatedDateMaxDaysBack/event/:eventId',
	conversations: () => '/conversations',
	downloads: () => '/downloads',
	help: () => '/help',
	home: () => '/home',
	mainPage: () => '/',
	notifications: () => '/notifications',
	outreach: () => '/outreach',
	profileEditor: () => '/profileEditor',
	register: () => '/register',
	requests: () => '/requests',
	resetPassword: () => '/reset-password/:userToken',
	reviewCopies: () => '/reviewCopies/:communityId',
	reviews: () => '/reviews',
	savedFilter: () => '/savedFilter/:viewId',
	search: () => '/search',
	shelfType: () => '/shelves',
	title: () => '/title/:sku',
	yourBooks: () => '/yourbooks',
};
